import { createContext } from 'react';
import { PspAppContext } from '../types';

/**
 * PSP Context definition.
 *
 * IMPORTANT: This file contains ONLY the Context object definition.
 * It must NOT import appRegistry, components, or anything that could create
 * circular dependencies. This ensures the Context object is never recreated
 * during HMR, which would break the Provider → Consumer connection.
 *
 * The Provider implementation lives in PspContext.tsx.
 */
export const PspContext = createContext<PspAppContext | undefined>(undefined);
